import { get, reduce } from 'lodash';
import { Dispatch } from 'redux';
import {
  NAAction,
  NAInProgressAction,
  NASubmit,
  NASubmitAction,
  NA_ANSWER,
  NA_IN_PROGRESS,
  NA_STARTED,
  NA_SUBMIT,
  NA_CHECKBOX,
  NA_COMPLETED,
  NAQuestionCategories,
  NAQuestionsPerCategory,
  NAQuestionsNumeric,
} from './types';
import { checkTrue } from '@trip-ux/common';
import { RESET_STORE, STORE } from '../global';

export const naSubmit =
  (data: NASubmit) =>
  (dispatch: Dispatch): void => {
    const convertedNA = convertNeedAnalysis(data);
    dispatch({
      type: NA_SUBMIT,
      payload: {
        ...data,
        paxNa: convertedNA
      }
    } as NASubmitAction);
  };

export const naAnswer = data => dispatch => {
  dispatch({
    type: NA_ANSWER,
    payload: data
  } as NAAction);
};

export const setNAInProgress = data => dispatch => {
  dispatch({
    type: NA_IN_PROGRESS,
    payload: data
  } as NAInProgressAction);
};

export const setNAStarted = (data: boolean) => dispatch => {
  dispatch({
    type: NA_STARTED,
    payload: data
  });
};
export const setCheckBoxState = (data: boolean) => dispatch => {
  dispatch({
    type: NA_CHECKBOX,
    payload: data
  });
};
export const setNaCompleted = (data: boolean) => dispatch => {
  dispatch({
    type: NA_COMPLETED,
    payload: data
  });
};

export const resetNA = () => dispatch => {
  dispatch({
    type: RESET_STORE,
    payload: {
      whitelist: [
        STORE.MQ,
        STORE.POLICY_CREATE,
        STORE.POLICY_GETPDF,
        STORE.QUOTE_FORM,
        STORE.TRAVELLER_DETAILS,
        STORE.TRAVELLER_PAYMENTS,
        STORE.TRAVELLER_PLAN,
        STORE.TRAVELLER_SELECTION
      ]
    }
  });
};

const convertNeedAnalysis = values => {
  const newObj = {};
  const { paxCount, paxNa } = values;
  for (const key in paxNa) {
    for (const question of NAQuestionsNumeric) {
      if (key.startsWith(question)) {
        paxNa[key] = paxNa[key] && paxNa[key].toString();
      }
    }
  }
  for (let i = 1; i <= paxCount; i++) {
    let questions = {};
    for (let j = 1; j <= NAQuestionCategories.length; j++) {
      const category = NAQuestionCategories[j - 1];
      const questionsPerSection =
        i > 1 && checkTrue(paxNa[`${category}-${i}-${j}`])
          ? {
              [category]: 'true'
            }
          : reduce(
              NAQuestionsPerCategory[category],
              (questionsNA, question) => {
                questionsNA[question] = get(paxNa, `${question}-${i}`);
                return questionsNA;
              },
              {}
            );
      questions = {
        ...questions,
        ...questionsPerSection
      };
    }
    newObj[i] = [
      {
        questions
      }
    ];
  }
  return newObj;
};
